import React from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
  strokeWidth?: number;
}

/**
 * Outline trophy (the Lucide "trophy" glyph, ISC). The repo's other trophies are
 * fills (the S3 nav icon is a medal, FontAwesome's faTrophy is solid), and the
 * homepage Leaderboard banner asks for a gold stroke, so the paths live here
 * rather than adding lucide-react for one icon.
 */
const TrophyIcon: React.FC<Props> = ({ className = '', size = 22, color = 'currentColor', strokeWidth = 1.8 }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
    <path d="M4 22h16" />
    <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
    <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
    <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
  </svg>
);

export default TrophyIcon;
